import styled from 'styled-components/macro';

export const Divider = styled.hr`
  margin: 5px 0 18px 0;
  color: #c4c4c4;
  opacity: 0.2;
`;
